import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { updatePackage } from '../../../services/packages'
import { UpdateUserPkgPayload } from '../types/UpdateUserPkgPayload'
import { UserPkg } from '../types/UserPkg'

export const useUpdateUserPackage = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: UpdateUserPkgPayload) => updatePackage(payload.packageId, payload.updateParam),
    onMutate: ({ packageId, updateParam }) => {
      queryClient.cancelQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
      const oldPkgs = queryClient.getQueryData([QUERY_KEYS.USER_PACKAGES])
      queryClient.setQueryData<UserPkg[]>([QUERY_KEYS.USER_PACKAGES], old =>
        old?.map(item => (item.id === packageId ? { ...item, ...updateParam } : item))
      )
      return { oldPkgs }
    },
    onError: (_error, _, context) => {
      if (context?.oldPkgs) {
        queryClient.setQueryData([QUERY_KEYS.USER_PACKAGES], context.oldPkgs)
      }
    },
  })
}
